<template>
  <div class="topico-texto mt-4 mb-5" v-html="texto">
  </div>
</template>

<script>
export default {
  name: 'TopicoTexto',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      texto: ''
    }
  },
  methods: {
    obterTopico: function () {
      this.texto = this.ementaCurso.topico_escolhido.texto
    }
  },
  mounted () {
    this.obterTopico()
  },
  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  }
}
</script>

<style scoped>

</style>
